<template>
  <div class="c-white-background" style="min-height:100vh">
    <MainNavBarWapV2 :object-data="infoHeader" />

    <!-- desktop >768px md -->
    <div class="desktop">
      <div
        class="container"
        style="padding-top: 100px; display: block; margin-left: auto; margin-right: auto"
      >
        <div style="width: 100%; text-align: center;  margin-bottom: 20px">
          <p style="font-size: 20px; font-weight: 600">{{ $t("history") }}</p>
        </div>
        <div
          class="flex justify-content-center align-items-center"
          style="width: 100%"
        >
          <div class="full-width search-bar-container">
            <img style="margin-left:10px" :src="bg.icon_search" alt="" />
            <el-input
              @input="handleInput"
              class="input-search-bar full-width"
              :placeholder="$t('searchByField')"
              v-model="facilityName"
            ></el-input>
            <img
              @click="
                () => {
                  this.facilityName = '';
                }
              "
              class="mr-10"
              :src="icons.CloseIcon"
              alt=""
            />
          </div>
          <img
            class="icon-frame"
            :src="isLatest ? icons.Up : icons.frame"
            alt=""
            @click="changeSort"
          />
          <p
            class="c-text-main flex-shrink-0 m-0 fw-cv1 c-tiny"
            @click="changeSort"
          >
            {{ buttonText }}
          </p>
        </div>
        <div style="min-height:500px" v-loading="isLoading" class="mt-20">
          <el-row :gutter="20">
            <el-col
              :xs="24"
              :sm="12"
              :md="8"
              :lg="8"
              v-for="(item, index) in listBill"
              :key="index"
              class="mt-10"
            >
              <div :key="index" class="box-bill">
                <wait-confirm :object-data="item" />
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <!-- end of desktop -->

    <!-- mobile <768px xs-->
    <div class="mobile">
      <div class="top-spacing">
        <div class="flex justify-content-center align-items-center px-15">
          <div class="full-width search-bar-container mt-6">
            <img style="margin-left:10px" :src="bg.icon_search" alt="" />
            <el-input
              @input="handleInput"
              class="input-search-bar full-width"
              :placeholder="$t('searchByField')"
              v-model="facilityName"
            ></el-input>
            <img
              @click="
                () => {
                  this.facilityName = '';
                }
              "
              class="mr-10"
              :src="icons.CloseIcon"
              alt=""
            />
          </div>

          <img
            class="icon-frame"
            :src="isLatest ? icons.Up : icons.frame"
            alt=""
            @click="changeSort"
          />
          <p
            class="c-text-main flex-shrink-0 m-0 fw-cv1 c-tiny"
            @click="changeSort"
          >
            {{ buttonText }}
          </p>
        </div>
      </div>
      <div class="divider-view-top" />
      <div style="transform: translateY(100px);" v-loading="isLoading"></div>
      <div>
        <div style="min-height: 100px;" class="px-15 mt-20 ">
          <div v-for="(item, index) in listBill" :key="index" class="box-bill ">
            <wait-confirm :object-data="item" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LogoWGHN from "@/assets/img/logo/WGHN.png";
import LocationIcon from "@/assets/img/svg/location_icon.svg";
import { getBackGround } from "@/utils/wapAuth";
import GlobalAPI from "@/views/api/wap/global";
import SearchIcon from "@/assets/img/svg/searchIcon.svg";
import Oval from "@/assets/img/svg/Oval.svg";
import Oval2 from "@/assets/img/svg/Oval2.svg";
import close from "@/assets/img/svg/close.svg";
import member from "@/assets/img/svg/member.svg";
import warning from "@/assets/img/svg/warning.svg";
import frame from "@/assets/img/svg/Frame.svg";
import Money from "@/assets/img/svg/money.svg";
import Teetime from "@/assets/img/svg/1.svg";
import GroupMember from "@/assets/img/svg/5.svg";
import Member from "@/assets/img/svg/2.svg";
import Time from "@/assets/img/svg/3.svg";
import Up from "@/assets/img/svg/up.svg";
import Clock from "@/assets/img/svg/clock.svg";
import MainNavBarWapV2 from "../../../../layout/WapV2/MainNavBar.vue";
import { formatNumber } from "@/plugins/init";
import WaitConfirm from "@/views/pages/wapV2/history/components/WaitConfirm.vue";

export default {
  components: {
    MainNavBarWapV2,
    WaitConfirm
  },
  props: {
    isShow: {
      type: Boolean,
      default: true
    }
  },
  created() {},
  data() {
    return {
      infoHeader: {
        title: this.$t("searchBtn"),
        isShowHomeIcon: true
      },
      isLoading: false,
      activeName: "1",
      isInsideWGHN: 1,
      sort: 1,
      listBill: [],
      isLatest: true,
      bg: getBackGround(),
      query: {},
      images: {
        LogoWGHN
      },
      icons: {
        LocationIcon,
        SearchIcon,
        Oval,
        close,
        Oval2,
        member,
        warning,
        frame,
        Money,
        Teetime,
        GroupMember,
        Member,
        Time,
        Clock,
        Up
      },
      dataFacility: [{ type: 1 }, { type: 2 }, { type: 3 }],
      facilityName: "",
      typingTimer: null,
      doneTypingInterval: 300
    };
  },
  computed: {
    buttonText() {
      return this.isLatest ? this.$t("farthestDate") : this.$t("nearestDate");
    }
  },
  watch: {},
  methods: {
    formatNumber,
    handleInput() {
      clearTimeout(this.typingTimer);
      this.typingTimer = setTimeout(this.remoteMethod, this.doneTypingInterval);
    },
    async remoteMethod() {
      if (this.facilityName === "" || this.facilityName === undefined) {
        return;
      }
      const body = {
        type: 0,
        limit: 10,
        page: 1,
        place: this.facilityName,
        sort: this.sort
      };
      this.handleFilter(body);
    },
    async changeSort() {
      this.sort = this.sort === 1 ? 2 : 1;
      const body = {
        type: 0,
        limit: 3,
        page: 1,
        place: this.facilityName,
        sort: this.sort
      };
      this.isLatest = !this.isLatest;
      this.handleFilter(body);
    },
    async handleFilter(body) {
      this.isLoading = true;
      const { data, error_code } = await GlobalAPI.searchFacility(body);
      if (error_code === 0) {
        this.listBill = data;
      }
      this.isLoading = false;
    },
    handleSelect(item) {
      this.facilityName = item.sub_title;
      this.facilityID = item.id;
    },
    handleClear() {
      this.facilityName = "";
      this.facilityID = "";
    },
    handleClose() {}
  }
};
</script>
<style>
.input-search .el-input input {
  width: 100%;
  border: none;
  background: #dee0e2;
  border-radius: 100px;
}
</style>

<style lang="scss" scoped>
.navbar-container {
  position: fixed;
  top: 55px;
  z-index: 1032;
  right: 0;
  width: 100%;
  padding: 10px 0;
}
.mr-10 {
  margin-left: 10px;
}
.text-head {
  flex-shrink: 0;
}

.mr-10 {
  margin-right: 10px;
}
.full-width {
  width: 100%;
}

.box-bill {
  border-radius: 5.931px;
  box-shadow: 0 0 3.558px 0 rgba(0, 0, 0, 0.15);
  width: 100%;
  flex-shrink: 0;
}

.icon-frame {
  color: #999999;
  margin: 0 10px;
  flex-shrink: 0;
}

.search-bar-container {
  border: 0.87px solid v-bind("bg.c_border3");
  background: v-bind("bg.c_background1");
  border-radius: 100px;
  height: 40px;
  display: flex;
  align-items: center;
}

.divider-view-top {
  height: 15px;
  width: 100%;
}

.column {
  flex-direction: column;
}

.desktop {
  display: block;
}

.mobile {
  display: none;
}

@media screen and (min-width: 0px) and (max-width: 480px) {
  .desktop {
    display: none;
  }
  .mobile {
    display: block;
  }
}

@media screen and (min-width: 0px) and (max-width: 769px) {
  .desktop {
    display: none;
  }
  .mobile {
    display: block;
  }
  .top-spacing {
    padding-top: 65px;
  }
}
</style>
